import dayjs from 'dayjs'

export const generateDate = (
    month = dayjs().month(),
    year = dayjs().year(),
) => {
    const firstDateOfMonth = dayjs().year(year).month(month).startOf("month")
    const lastDateOfMonth = dayjs().year(year).month(month).endOf("month")
    
    const arrayOfDate = []


    for(let i = firstDateOfMonth.date(); i<=lastDateOfMonth.date(); i++){
        arrayOfDate.push({
            date: firstDateOfMonth.date(i),
            currentMonth: true,
            todays_day:dayjs().date(),
            today:
                firstDateOfMonth.date(i).toDate().toDateString() ===
                dayjs().toDate().toDateString()
        })
    }
    
    return arrayOfDate
    
}
